import { render, staticRenderFns } from "./EditHotness.vue?vue&type=template&id=dd81abac&lang=pug"
import script from "./EditHotness.vue?vue&type=script&lang=js"
export * from "./EditHotness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports